import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EndSessionRequest } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';

import { UserLoggedOutMessage } from '@core/messages';
import { ApplicationConfiguration } from '@core/configuration';
import { securityLog } from '../helpers';
import { AccountContextService, AuthAccountService, AuthRequestBuilderService, AuthStateService } from '../services';

@Injectable({
    providedIn: 'root'
})
export class LogoutCommand {
    constructor(
        private applicationConfig: ApplicationConfiguration,
        private msalService: MsalService,
        private accountContext: AccountContextService,
        private accountService: AuthAccountService,
        private authRequestBuilder: AuthRequestBuilderService,
        private authState: AuthStateService,
        private router: Router,
    ) { }

    public execute(message: UserLoggedOutMessage): void {
        securityLog.debug('LogoutCommand: execute', { authFailed: message.authFailed });

        this.authState.resetLoginPublication();
        this.authState.clearTokenRefreshTimeout();
        this.accountContext.clearPinnedAccountInformation();

        const activeAccount = this.accountService.getActiveAccount();

        this.applicationConfig.tenant = '';
        this.accountService.setActiveAccount(null);

        if (message.authFailed) {
            this.authRequestBuilder.setForcePromptLogin(true);
        }

        const logoutRequest: EndSessionRequest = {
            account: activeAccount || undefined,
            postLogoutRedirectUri: message.authFailed
                ? '/login-failed'
                : '/'
        };

        try {
            this.msalService.instance.clearCache();
        }
        catch (error) {
            securityLog.warn('LogoutCommand: MSAL manual cache clear failed', error);
        }

        this.msalService.logoutRedirect(logoutRequest).subscribe({
            error: error => {
                securityLog.error('LogoutCommand: MSAL logout redirect failed', error);
                if (error && error.toString().indexOf('interaction_in_progress') > -1 && message.authFailed) {
                    this.router.navigateByUrl('/login-failed').catch((navigationError) => {
                        securityLog.error('LogoutCommand: failed to navigate to /login-failed after logout redirect failure', navigationError);
                    });
                }
            }
        });
    }
}